// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { IconWrapper } from "@insite/mobius/Icon";
import { paginationStyles } from "@sc/Overrides/Widgets/ProductList/ProductListPagination";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

paginationStyles.pagination = {
    cssOverrides: {
        pagination: css`
            ${xScreen("lte", "xs")} {
                justify-content: flex-end;
            }
        `,
        perPageSelect: css`
            ${xScreen("lte", "md")} {
                &.perPageSelect {
                    margin: 0;
                    width: 100%;
                    [class^="FormFieldStyle"] {
                        flex-direction: column;
                        align-items: baseline;
                        ${IconWrapper} {
                            height: 32px;
                        }
                        select {
                            height: 36px;
                        }
                    }
                }
            }
        `,
        linkList: css`
            ${xScreen("lte", "md")} {
                justify-content: flex-end;
            }
        `,
    },
    selectProps: {
        cssOverrides: {
            formInputWrapper: css`
                &&&& {
                    select {
                        padding-right: 30px;
                        ${xScreen("lte", "md")} {
                            text-align: left;
                        }
                    }
                }
            `,
        },
    },
};
